import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EditNavaidComponent } from '../edit-navaid/edit-navaid.component';
import { NavaidService } from '../service/navaid.service';

@Component({
  selector: 'app-delete-navaid',
  templateUrl: './delete-navaid.component.html',
  styleUrls: ['./delete-navaid.component.scss']
})
export class DeleteNavaidComponent implements OnInit {
  navaidId: number;
  isLoading = false;

  constructor(private _matDialogRef: MatDialogRef<EditNavaidComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _NavaidService: NavaidService) {
    this.navaidId = data.navaidId;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  async delete() {
    try {
      this.isLoading = true;
      await this._NavaidService.deleteNavaid(this.navaidId);
      this.isLoading = false;
      this.close({success: true, navaidId: this.navaidId});
    } catch (e) {
      this.close({success: false, error: e});
    }
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }
}
